<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="observer">
      <v-form>
        <v-card
          v-if="manifestId"
          flat
        >
          <v-toolbar flat>
            <v-toolbar-title>JWNET備考の編集</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <!-- 備考１ -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="備考１"
                  rules="max: 25"
                >
                  <v-text-field
                    v-model="forms.note_1"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="備考１"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>備考１</span>
                      <span class="ml-1">
                        ({{ forms.note_1?.length || 0 }} / 25)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /備考１ -->

            <!-- 備考２ -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="備考２"
                  rules="max: 25"
                >
                  <v-text-field
                    v-model="forms.note_2"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="備考２"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>備考２</span>
                      <span class="ml-1">
                        ({{ forms.note_2?.length || 0 }} / 25)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /備考２ -->

            <!-- 備考３ -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="備考３"
                  rules="max: 25"
                >
                  <v-text-field
                    v-model="forms.note_3"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="備考３"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>備考３</span>
                      <span class="ml-1">
                        ({{ forms.note_3?.length || 0 }} / 25)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /備考３ -->

            <!-- 備考４ -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="備考４"
                  rules="max: 25"
                >
                  <v-text-field
                    v-model="forms.note_4"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="備考４"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>備考４</span>
                      <span class="ml-1">
                        ({{ forms.note_4?.length || 0 }} / 25)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /備考４ -->

            <!-- 備考４ -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="備考５"
                  rules="max: 25"
                >
                  <v-text-field
                    v-model="forms.note_5"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="備考５"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>備考５</span>
                      <span class="ml-1">
                        ({{ forms.note_5?.length || 0 }} / 25)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /備考５ -->
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
    <send-mail-confirmable-dialog
      :manifest-id="manifestId"
      :enable-dialog="enableMailConfirmableDialog"
      @negativeCallback="negativeCallback"
      @positiveCallback="positiveCallback"
    />
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import SendMailConfirmableDialog from '@/driver/pages/manifest/managements/dialogs/_SendMailConfirmableDialog.vue'

export default {
  name: 'EditTransportNoteDialog',
  components: {
    SendMailConfirmableDialog,
  },
  mixins: [],
  props: {
    manifestId: {
      type: Number,
      default: () => null,
    },
    enableDialog: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      enableMailConfirmableDialog: false,
      forms: {
        note_1: null,
        note_2: null,
        note_3: null,
        note_4: null,
        note_5: null,
      }
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (newValue) {
        this.setVariable()
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestManagementTransportNote', {
      fetchNote: 'edit',
      updateNote: 'update',
    }),
    ...mapActions("DriverManifestManagementVerifyTransportNote", {
      verifyTransportNote: "update",
    }),
    setVariable () {
      this.fetchNote({ id: this.manifestId }).then((content) => {
        this.forms = content
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    negativeCallback () {
      this.enableMailConfirmableDialog = false;
    },
    positiveCallback () {
      this.updateManifest()
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if(result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      let params = this.buildParams();
      this.verifyTransportNote({ id: this.manifestId, params: params }).then((content) => {
        if (content.changed) {
          this.enableMailConfirmableDialog = true;
        } else {
          this.updateManifest(params);
        }
      })
    },
    updateManifest () {
      let params = this.buildParams()
      this.updateNote({ id: this.manifestId, params: params }).then(() => {
        this.enableMailConfirmableDialog = false;
        this.$emit('registerCallback')
      })
    },
    buildParams () {
      let params = this.forms
      return params;
    },
  }
}
</script>

<style scoped>

</style>
